<template>
    <div class="company-project-link-list" v-if="companyProjects && companyProjects.length > 0">
        <div v-for="(companyProject) in shownItems" :key="companyProject.id" class="company-project-entry">
            <company-project-card :company-project="companyProject"/>
        </div>
        <b-collapse :id="collapseKey">
            <div v-for="(companyProject) in hiddenItems" :key="companyProject.id" class="company-project-entry">
                <company-project-card :company-project="companyProject"/>
            </div>
        </b-collapse>
        <b-button v-b-toggle="collapseKey"
                  v-if="toggleText"
                  @click="collapseOpen = !collapseOpen">
            {{ toggleText }}
        </b-button>
    </div>
</template>

<script>
import Authorization from '@/providers/Authorization'
import Vue from 'vue'

export default {
    name: 'CompanyProjectLinkList',
    props: {
        companyProjects: Array,
        collapseKey: String
    },
    data () {
        return {
            collapseOpen: false,
        }
    },
    computed: {
        shownItems () {
            return this.companyProjects.slice(0, 2)
        },
        hiddenItems () {
            return this.companyProjects.slice(2)
        },
        toggleText () {
            if (this.hiddenItems.length > 0) {
                return this.collapseOpen ? 'Hide' : ('Show ' + this.hiddenItems.length + ' more')
            }
            return null
        }
    },
    created () {
        if (this.companyProjects) {
            this.companyProjects.forEach((companyProject) => {
                Authorization.can({ action: 'view', model: 'company', arg: companyProject.company_id }).then((can) => {
                    Vue.set(companyProject, 'canView', can)
                })
            })
        }
    },
}
</script>

<style lang="scss">
.company-project-entry {
    padding: 10px;
    border: solid 1px #ccc;
    margin: 10px 0;
}

</style>
